import React from 'react';
import { AlertCircle, LogIn } from 'lucide-react';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ isOpen, onClose }) => {
  // console.log('🔍 SessionExpiredModal - isOpen:', isOpen);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0">
            <AlertCircle className="h-8 w-8 text-red-500" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Sesión expirada</h3>
            <p className="text-sm text-gray-600">Su sesión ha expirado por falta de actividad</p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-6 p-3 bg-red-50 rounded-md">
          <LogIn className="h-5 w-5 text-red-600" />
          <span className="text-sm text-red-800">
            Por favor, inicie sesión nuevamente para continuar
          </span>
        </div>

        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="bg-brand-orange text-white px-6 py-2 rounded-md hover:bg-orange-600 transition-colors font-medium flex items-center gap-2"
          >
            <LogIn className="h-4 w-4" />
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}; 